// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"8c7e964c","121":"89575f1c","130":"2a353631","415":"ae7e76c6","552":"24c7a3ac","728":"10f9c286"}[chunkId] + ".chunk.js";
};